export { IncotermsValue } from '@zen/graphql/types.generated';

export enum BookingScope {
  APPROVED = 'APPROVED',
  CONFIRMED = 'CONFIRMED',
  DRAFTS = 'DRAFTS',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED'
}
